import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { SignatureDocument, SignatureDocumentUsers, SignersInfo } from '../../../model/signatureDocumentUsers';
import { Subject, takeUntil } from 'rxjs';
import { User } from '../../../model/user';
import { UserService } from '../../../services/user.service';
import { SpinnerService } from '../../../services/spinner.service';
import { SignatureDocumentUsersService } from '../../../services/signatureDocumentUsers.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SignatureDocumentsService } from '../../../services/signatureDocuments.service';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../services/snackBar.service';
import { ActionConfirmPasswordComponent } from '../../shared/action-confirm-password/action-confirm-password.component';
import { ReasonDialogComponent } from '../../shared/reason-dialog/reason-dialog.component';
import * as _ from 'lodash-es';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { LangFlag, TranslationService } from '../../../services/translation.service';
import { EmailUtil } from '../../../utils/emailUtil';
import { ProtocolQService } from '../../../services/protocolQ.service';
import { DocumentListEnum } from '../../../utils/documentListUtils';
import { ProtocolService } from '../../../services/protocol.service';
import { ExecutionReportFilter, ProtocolReportFilter } from '../../../model/attachment';
import { ThemeService } from '../../../services/theme.service';
import { ExecutionAuditService } from '../../../services/executionAudit.service';
import { ExecutionAuditActionEnum } from '../../../model/execution';
import { ExecutionAudit } from 'src/app/model/execution';

export interface DialogDataSigner {
  idDocument: number;
  nDocument: string;
  documentType: number;
  idClient: number;
  currentVersion: number;
  isEdit: boolean;
  isNotPrepare: boolean;
  reportConfig: ExecutionReportFilter | ProtocolReportFilter | string[];
  isManual: boolean;
}

@Component({
    selector: 'app-signature-edit-signers',
    templateUrl: './signature-edit-signers.component.html',
    styleUrls: ['./signature-edit-signers.component.scss'],
    standalone: false,
})
export class SignatureEditSignersComponent implements OnInit {

  colores: string[] = ['#FF5733', '#33FF57', '#3357FF', '#FF33A6', '#FFD700', '#FF5733', '#33FF57', '#3357FF', '#FF33A6', '#FFD700'];

  typeSigners: any[] = [{ id: 3, translation: 'generateBy' },{ id: 1, translation: 'reviewedBy' },{ id: 2, translation: 'approvedBy' }];
  
  currentUser: User;
  respDocs: SignersInfo[];
  respDocsFiltered: SignersInfo[];
  document: SignatureDocument;
  signersDatasource: SignatureDocumentUsers[];
  calculatedColors: Map<number, string> = new Map();
  langs: LangFlag[];
  lang: string;

  private destroy$ = new Subject<void>();

  constructor(private signatureDocumentUsersService: SignatureDocumentUsersService,
    private signatureDocumentsService: SignatureDocumentsService,
    private userService: UserService,
    private spinnerService: SpinnerService,
    private protocolQService: ProtocolQService,
    private protocolService: ProtocolService,
    private executionAuditService: ExecutionAuditService,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataSigner,
    private translate: TranslateService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SignatureEditSignersComponent>,
    private translationService: TranslationService,
    private snackBarService: SnackBarService,
    private themeService: ThemeService,
      private cdr: ChangeDetectorRef) {
    this.currentUser = this.userService.currentProfile;
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.langs = this.translationService.configuredLangs;

    if (!this.document) {
      this.document = new SignatureDocument();

      if (this.data.isManual) {
        this.document.manual = true;
      }
    }

    this.signatureDocumentUsersService.findAllUsersSignature().pipe(takeUntil(this.destroy$)).subscribe((item: SignersInfo[]) => {
      const sorted = item.sort((v1, v2) => v1.fullName.localeCompare(v2.fullName));
      this.respDocs = sorted;

      this.signatureDocumentsService.findByIdDocumentAndIdType(this.data.idDocument, this.data.documentType, this.data.currentVersion, true).pipe(takeUntil(this.destroy$)).subscribe((item: SignatureDocument) => {
        if (item) {
          this.document = item;
          this.signersDatasource = item.documentUsers?.sort((a, b) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0));
          this.spinnerService.hide();
        } else {
         if (this.data.documentType === DocumentListEnum.EXECUTION_THERMAL) {
          if (!this.signersDatasource) {
            this.signersDatasource = [];
          }
          this.executionAuditService.getAuditByAction(this.data.idDocument, ExecutionAuditActionEnum.VALIDATE).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionAudit) => {
              if (item) {
                let userSigner = new SignatureDocumentUsers();
                userSigner.username = item.username;
                userSigner.typeSigner = 3;
                userSigner.disabled = true;
                userSigner.internal = true;
                userSigner.onlyCopy = false;
                userSigner.fullName = this.respDocs.find(rd => rd.username ===  item.username).fullName;
                userSigner.email = this.respDocs.find(rd => rd.username ===  item.username).email;
                
                this.signersDatasource.push(userSigner)
              }
            });

            this.executionAuditService.getAuditByAction(this.data.idDocument, ExecutionAuditActionEnum.EDITION_NEW_VERSION).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionAudit) => {
              if (item) {
                let userSigner = new SignatureDocumentUsers();
                userSigner.username = item.username;
                userSigner.typeSigner = 4;
                userSigner.disabled = true;
                userSigner.internal = true;
                userSigner.onlyCopy = false;
                userSigner.fullName = this.respDocs.find(rd => rd.username ===  item.username).fullName;
                userSigner.email = this.respDocs.find(rd => rd.username ===  item.username).email;

                this.signersDatasource.push(userSigner)
              }
              this.spinnerService.hide();
            });

          } else {
            this.spinnerService.hide();
          }
        }
      });
    });
  }

  addSigners() {
    if (!this.signersDatasource) {
      this.signersDatasource = [];
    } else {
      this.signersDatasource.forEach(e => e.position = null);
    }

    this.respDocsFiltered = _.cloneDeep(this.respDocs);

    this.signersDatasource.push(new SignatureDocumentUsers());
  }

  prepareToSave(): void {
    const errores = this.getErrorsSign();

    if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    } else {
      this.onOkClick();
    }
  }

  getErrorsSign(): string[] {
    const errores: string[] = [];

    if (!this.document.lang) {
      errores.push(this.translate.instant('signatureDocument.lang.empty') as string);
    }

    if (!this.signersDatasource) {
      errores.push(this.translate.instant('signatureDocument.singature.empty') as string);
    } else {
      let validateSigner = false;
      
      for (let index = 0; index < this.signersDatasource.length; index++) {
        const element = this.signersDatasource[index];

        if (element.idStatus != 4) {
          if (!this.data.isManual) {
            if (!element.email) {
              errores.push(this.translate.instant('signatureDocument.email.empty') as string);
            } else if (!EmailUtil.validEmail(element.email)) {
              errores.push(this.translate.instant('signatureDocument.email.error') as string);
            }
          }
         
          if (!element.role) {
            errores.push(this.translate.instant('signatureDocument.role.empty') as string);
          }

          if (!element.fullName) {
            errores.push(this.translate.instant('signatureDocument.fullName.empty') as string);
          }
  
          if (!element.onlyCopy && !element.typeSigner) {
            errores.push(this.translate.instant('signatureDocument.typeSigner.empty') as string);
          }
          /*onst resOtherSigner = this.signersDatasource.some(rfg => rfg.email === element.email && (rfg.typeSigner === 1 || rfg.typeSigner === 2));
          if (resOtherSigner) {
            errores.push(this.translate.instant('signatureDocument.otherSigner.error') as string);
          }*/
  
          if (!this.data.isManual) {
            if (!validateSigner) {
              const sameEmailSigners = this.signersDatasource.filter(rfg => rfg.email === element.email && rfg.idStatus != 4);
              const hasType1 = sameEmailSigners.some(s => s.typeSigner === 3);
              const hasInvalidCombination = hasType1 && sameEmailSigners.some(s => s.typeSigner === 1 || s.typeSigner === 2);
              if (hasInvalidCombination) {
                validateSigner = true;
                errores.push(this.translate.instant('signatureDocument.otherSigner.error') as string);
              }
            }
          }
        }
      }

      if (!this.data.isNotPrepare) {
        const notExistGenerate = this.signersDatasource.filter(edf => edf.typeSigner === 3 && edf.idStatus != 4);
        if (!notExistGenerate || notExistGenerate?.length === 0) {
          errores.push(this.translate.instant('signatureDocument.notExists.generate.error') as string);
        }
      }
      
      const notExistApproved = this.signersDatasource.filter(edf => edf.typeSigner === 2 && edf.idStatus != 4);
      if (!notExistApproved || notExistApproved?.length === 0) {
        errores.push(this.translate.instant('signatureDocument.notExists.approved.error') as string);
      }

      if (!this.data.isManual) {
        const duplicates = this.signersDatasource.filter((signer, index, self) => {
          if (signer.idStatus === 4) return false;
          
          return self.findIndex(s =>
            s.email === signer.email && s.typeSigner === signer.typeSigner && s.idStatus !== 4
          ) !== index;
        });

        if (duplicates && duplicates?.length > 0) {
          errores.push(this.translate.instant('signatureDocument.duplicateSigner.error') as string);
        }
      }

      if (!this.validarOrden(this.signersDatasource)) {
        const orderLabels = this.typeSigners.map(t => this.translate.instant('signatureDocument.typeSigner.' + t.translation));
        const orderStr = orderLabels.join(' → ');
        const mensaje = this.translate.instant('signatureDocument.orderSigner.error', { order: orderStr });
        errores.push(mensaje as string);
      }
    }

    return errores;
  }

  onOkClick() {
    if (!this.document?.id) {
      this.document.idType = this.data.documentType;
      this.document.idDocument = this.data.idDocument;
      this.document.idClient = this.data.idClient;
      this.document.documentCode = this.data.nDocument;
      this.document.currentVersion = this.data.currentVersion;
      if (this.data.reportConfig) {
        this.document.reportConfig = JSON.stringify(this.data.reportConfig);
      }
      this.signersDatasource?.forEach((element, index) => {
        element.position = index + 1;
        if (this.signersDatasource[index].onlyCopy === null) {
          this.signersDatasource[index].onlyCopy = false;
        }
      });
      this.document.documentUsers = this.signersDatasource;
    }

    this.spinnerService.show();
    this.signatureDocumentsService.save(this.document).pipe(takeUntil(this.destroy$)).subscribe((item: SignersInfo[]) => {
      if (item) {
        if (!this.document.id) {
          switch (this.document.idType) {
            case DocumentListEnum.PROTOCOL_QUALIFICATES:
              this.protocolQService.generateReportSignatureTemp(this.document.idDocument, this.document.currentVersion).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.dialogRef.close(this.document);
              }, error => {
                 console.log(error);
                 this.spinnerService.hide();
              });
              break;
            case DocumentListEnum.EXECUTION_QUALIFICATES:
              this.protocolQService.generateReportExecutionSignatureTemp(this.document.idDocument, this.document.currentVersion).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.dialogRef.close(this.document);
              }, error => {
                console.log(error);
                this.spinnerService.hide();
              });
              break;
            case DocumentListEnum.PROTOCOL_THERMAL:
              this.protocolService.generateReportSignatureTemp(this.document.idDocument, this.document.currentVersion).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.dialogRef.close(this.document);
              }, error => {
                console.log(error);
                this.spinnerService.hide();
              });
              break;
            case DocumentListEnum.ANNUAL_CALIBRATION:
              this.spinnerService.hide();
              this.dialogRef.close('save');
              break;
            default:
              this.spinnerService.hide();
              this.dialogRef.close();
              break;
          }
        } else {
          this.spinnerService.hide();
          this.dialogRef.close();
        }
      }


    }, error => {
      console.log(error);
      this.spinnerService.hide();
    });

  }

  onNoClick() {
    this.dialogRef.close(null);
  }

  deleteSigner(index: number) {
    if (this.data.isManual) {
      this.signersDatasource.splice(index, 1);
    } else {
      this.signersDatasource[index].idStatus = 4;

      this.cdr.detectChanges();
    }
  }

  getRangeColor(index: number): string {
    if (index < this.colores.length) {
      return this.colores[index];
    } else {
      if (this.calculatedColors.has(index)) {
        return this.calculatedColors.get(index)!;
      }

      let numAleatorio = index - 5;

      if (numAleatorio < 1 || numAleatorio > 10) {
        numAleatorio = Math.floor(Math.random() * 10) + 1;
      }

      const color = this.getColorFromNumber(numAleatorio);
      this.calculatedColors.set(index, color);

      return color;
    }
  }

  getColorFromNumber(num: number): string {
    const colors = ['#FF5733', '#33FF57', '#3357FF', '#57FF33', '#FF33A1', '#A133FF', '#FF3333', '#FF8C00', '#8CFF00', '#00FF8C'];
    return colors[num - 1] || '#000000';
  }

  onUserChange(event: any, userIndex: number): void {
    const userSelected = event.option.value as SignersInfo;
    const user = this.signersDatasource[userIndex];

    user.email = userSelected.email;
    user.username = userSelected.username;
    user.fullName = userSelected.fullName;
    user.internal = userSelected.internal;
    user.onlyCopy = userSelected.onlyCopy;
    user.role = userSelected.role;
  }

  displayFn(user?: any | string | { name: string }): string {
    if (!user) {
      return null;
    }

    let res: string = null;

    if (typeof user === 'string') {
      res = user;
    } else if (user instanceof User || user.name != null) {
      res = user.fullName;
    }

    return res;
  }

  lookupUsers($event) {
    const data = $event.target.value.toLowerCase();
    this.respDocsFiltered = [...this.respDocs].filter(e => e.fullName.toLowerCase().includes(data));
  }

  deleteSigners() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('signatureDocument.delete.signers.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        this.requestReason((reason) => {
          this.requestSign((result) => {
            this.spinnerService.show();
            this.signatureDocumentsService.deleteById(this.document.id, reason).pipe(takeUntil(this.destroy$)).subscribe(() => {
              this.spinnerService.hide();
              this.snackBarService.sendSuccess(this.translate.instant('signatureDocument.delete.signers.ok') as string);
              this.signersDatasource = [];
              this.document = new SignatureDocument();
              if (this.data.documentType === DocumentListEnum.EXECUTION_THERMAL) {
                this.dialogRef.close();
              } else if (!this.data.isManual &&this.data.documentType === DocumentListEnum.ANNUAL_CALIBRATION) {
                this.dialogRef.close('delete');
              } else if (this.data.isManual &&this.data.documentType === DocumentListEnum.ANNUAL_CALIBRATION) {
                this.dialogRef.close('manual');
              }
            }, error => {

              this.snackBarService.sendError(this.translate.instant('signatureDocument.delete.signers.error') as string);

              this.spinnerService.hide();
            });
          });
        });
      }
    });
  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }

  getCurrentUserSigner(user: SignatureDocumentUsers): string {
    const res = this.signersDatasource.filter(e => e.username === user.username && e.signatureDate != null);

    if (res?.length > 0) {
      return 'success';
    } else {
      const res = this.signersDatasource.filter(e => e.username === user.username && e.signatureDate == null && e.idStatus === 3);

      if (res?.length > 0) {
        return 'rejected';
      } else {
        return 'pending';
      }
    }

  }

  showReject(user: SignatureDocumentUsers): boolean {
    return user.idStatus === 3;
  }

  inactiveSignature(): boolean {
    if (this.document.id && !this.document.active) {
      return false;
    } if (!this.document || !this.document.id) {
      return false;
    } else if (this.document.regUser === this.currentUser.username){
      return false;
    } else {
      const res = this.signersDatasource.filter(e => e.idStatus === 3);

      if (res && res.length > 0) {
         return false;
      } else  {
         return true;
      }
     
    }
  }

  disabledSigned(user: SignatureDocumentUsers) {
    return (this.data.isManual ? false : (this.inactiveSignature() || user.signatureDate || user.disabled || user.idStatus === 3));
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }


  private requestReason(callback: (reason: string) => void) {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }


  private requestSign(callback: (token: string) => void) {
    this.spinnerService.hide();

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.signersDatasource, event.previousIndex, event.currentIndex);

      this.signersDatasource.forEach((element, index) => {
        element.position = index + 1;
      });
    }
  }

  disableUserSelected(username: string) {
    return this.signersDatasource.find(rp => rp.username === username) !== null;
  }

  disableSign() {
    return this.document.idStatus === 1;
  }

  trackBySigner(index: number, signer: any): any {
    return signer.id || index;
  }

  validarOrden(documentUsers: any[]): boolean {
    const ordenTypeSigners = {
      3: 1,
      1: 2,
      2: 3
    };
    
    const orden = documentUsers.map(u => ordenTypeSigners[u.typeSigner]);

    for (let i = 1; i < orden.length; i++) {
      if (orden[i] < orden[i - 1]) {
        return false;
      }
    }

    return true;
  }
}
